(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8480],{

/***/ 37598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30067);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58290);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87596);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16600);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["onChange", "maxRows", "minRows", "style", "value"];







function getStyleValue(computedStyle, property) {
  return parseInt(computedStyle[property], 10) || 0;
}

const styles = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: 'hidden',
    // Remove from the content flow
    position: 'absolute',
    // Ignore the scrollbar width
    overflow: 'hidden',
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: 'translateZ(0)'
  }
};

function isEmpty(obj) {
  return obj === undefined || obj === null || Object.keys(obj).length === 0;
}

const TextareaAutosize = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function TextareaAutosize(props, ref) {
  const {
    onChange,
    maxRows,
    minRows = 1,
    style,
    value
  } = props,
        other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, _excluded);

  const {
    current: isControlled
  } = react__WEBPACK_IMPORTED_MODULE_0__.useRef(value != null);
  const inputRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const handleRef = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ref, inputRef);
  const shadowRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const renders = react__WEBPACK_IMPORTED_MODULE_0__.useRef(0);
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({});
  const getUpdatedState = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => {
    const input = inputRef.current;
    const containerWindow = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(input);
    const computedStyle = containerWindow.getComputedStyle(input); // If input's width is shrunk and it's not visible, don't sync height.

    if (computedStyle.width === '0px') {
      return {};
    }

    const inputShallow = shadowRef.current;
    inputShallow.style.width = computedStyle.width;
    inputShallow.value = input.value || props.placeholder || 'x';

    if (inputShallow.value.slice(-1) === '\n') {
      // Certain fonts which overflow the line height will cause the textarea
      // to report a different scrollHeight depending on whether the last line
      // is empty. Make it non-empty to avoid this issue.
      inputShallow.value += ' ';
    }

    const boxSizing = computedStyle['box-sizing'];
    const padding = getStyleValue(computedStyle, 'padding-bottom') + getStyleValue(computedStyle, 'padding-top');
    const border = getStyleValue(computedStyle, 'border-bottom-width') + getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content

    const innerHeight = inputShallow.scrollHeight; // Measure height of a textarea with a single row

    inputShallow.value = 'x';
    const singleRowHeight = inputShallow.scrollHeight; // The height of the outer content

    let outerHeight = innerHeight;

    if (minRows) {
      outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
    }

    if (maxRows) {
      outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
    }

    outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.

    const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
    const overflow = Math.abs(outerHeight - innerHeight) <= 1;
    return {
      outerHeightStyle,
      overflow
    };
  }, [maxRows, minRows, props.placeholder]);

  const updateState = (prevState, newState) => {
    const {
      outerHeightStyle,
      overflow
    } = newState; // Need a large enough difference to update the height.
    // This prevents infinite rendering loop.

    if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
      renders.current += 1;
      return {
        overflow,
        outerHeightStyle
      };
    }

    if (false) {}

    return prevState;
  };

  const syncHeight = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => {
    const newState = getUpdatedState();

    if (isEmpty(newState)) {
      return;
    }

    setState(prevState => {
      return updateState(prevState, newState);
    });
  }, [getUpdatedState]);

  const syncHeightWithFlushSycn = () => {
    const newState = getUpdatedState();

    if (isEmpty(newState)) {
      return;
    } // In React 18, state updates in a ResizeObserver's callback are happening after the paint which causes flickering
    // when doing some visual updates in it. Using flushSync ensures that the dom will be painted after the states updates happen
    // Related issue - https://github.com/facebook/react/issues/24331


    (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.flushSync)(() => {
      setState(prevState => {
        return updateState(prevState, newState);
      });
    });
  };

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    const handleResize = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(() => {
      renders.current = 0; // If the TextareaAutosize component is replaced by Suspense with a fallback, the last
      // ResizeObserver's handler that runs because of the change in the layout is trying to
      // access a dom node that is no longer there (as the fallback component is being shown instead).
      // See https://github.com/mui/material-ui/issues/32640

      if (inputRef.current) {
        syncHeightWithFlushSycn();
      }
    });
    const containerWindow = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(inputRef.current);
    containerWindow.addEventListener('resize', handleResize);
    let resizeObserver;

    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(inputRef.current);
    }

    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);

      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  });
  (0,_mui_utils__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(() => {
    syncHeight();
  });
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    renders.current = 0;
  }, [value]);

  const handleChange = event => {
    renders.current = 0;

    if (!isControlled) {
      syncHeight();
    }

    if (onChange) {
      onChange(event);
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("textarea", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
      value: value,
      onChange: handleChange,
      ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
      ,
      rows: minRows,
      style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        height: state.outerHeightStyle,
        // Need a large enough difference to allow scrolling.
        // This prevents infinite rendering loop.
        overflow: state.overflow ? 'hidden' : null
      }, style)
    }, other)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("textarea", {
      "aria-hidden": true,
      className: props.className,
      readOnly: true,
      ref: shadowRef,
      tabIndex: -1,
      style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, styles.shadow, style, {
        padding: 0
      })
    })]
  });
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (TextareaAutosize);

/***/ }),

/***/ 49922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TopRankUniCard */
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4730);
/* harmony import */ var _mui_material_Menu__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(32819);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72145);
/* harmony import */ var _recoil_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89093);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86893);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2804);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(71285);
/* harmony import */ var _top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _unisearch_common_ui_element_actions_chat_connect__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90312);
/* harmony import */ var _unisearch_common_ui_element_actions_conversation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10534);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);

var _excluded = ["data", "fetchFavUniData"];

















var FavoriteAction = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3609), __webpack_require__.e(5494)]).then(__webpack_require__.bind(__webpack_require__, 25494));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(25494)];
    }
  }
});
var CompareAction = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3609), __webpack_require__.e(6723)]).then(__webpack_require__.bind(__webpack_require__, 76723));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(76723)];
    }
  }
});
var TopRankUniCard = function TopRankUniCard(_ref) {
  var _data$popularCourse, _data$popularCourse2, _data$popularCourse3;

  var data = _ref.data,
      fetchFavUniData = _ref.fetchFavUniData,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_ref, _excluded);

  var profileInfo = (0,recoil__WEBPACK_IMPORTED_MODULE_5__/* .useRecoilValue */ .sJ)(_recoil_state__WEBPACK_IMPORTED_MODULE_1__/* .authAtom */ .L4);
  var route = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null),
      anchorEl = _useState[0],
      setAnchorEl = _useState[1];

  var open = Boolean(anchorEl);

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  }; // console.log(data);


  var link = "/study/".concat(data === null || data === void 0 ? void 0 : data.countrySlug, "/university/").concat(data === null || data === void 0 ? void 0 : data.universitySlug);
  var courseLink = "/study/".concat(data === null || data === void 0 ? void 0 : data.countrySlug, "/university/").concat(data === null || data === void 0 ? void 0 : data.universitySlug, "/courses");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material_Menu__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
      className: "popular_course_dropdown ".concat((_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().popular_course_dropdown)),
      id: "basic-menu",
      anchorEl: anchorEl,
      open: open,
      onClose: handleClose,
      MenuListProps: {
        "aria-labelledby": "basic-button"
      },
      sx: {
        padding: "0px"
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
        className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().popular_course_dropdown_wrapper),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
          className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().dropdown_heading_wrapper),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
            children: "Popular Courses"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_14__/* .FiX */ .q5L, {
            onClick: handleClose
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
          className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().dropdown_body_wrapper),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("ul", {
            children: data && (data === null || data === void 0 ? void 0 : (_data$popularCourse = data.popularCourse) === null || _data$popularCourse === void 0 ? void 0 : _data$popularCourse.length) > 0 && ((_data$popularCourse2 = data.popularCourse) === null || _data$popularCourse2 === void 0 ? void 0 : _data$popularCourse2.map(function (course, i) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                  className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().course),
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                    className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().course_level),
                    children: course === null || course === void 0 ? void 0 : course.levelName
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                    legacyBehavior: true,
                    href: "".concat(link, "/").concat(course === null || course === void 0 ? void 0 : course.courseSlug),
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                      className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().course_name),
                      children: course === null || course === void 0 ? void 0 : course.courseName
                    })
                  })]
                })
              }, i);
            }))
          })
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
      className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_rank_card),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
        className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().favorite_wrapper),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(FavoriteAction, {
          fetchFavUniData: fetchFavUniData,
          referance: "university",
          referanceId: parseInt(data.universityId),
          is_favorite: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .isUniFavorite */ .bt)(profileInfo, data.universityId)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(CompareAction, {
          referance: "university",
          referanceId: parseInt(data.universityId),
          is_compared: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .isUniCompare */ .j1)(profileInfo, data.universityId)
        }), ((route === null || route === void 0 ? void 0 : route.pathname) === "/app/student/favorite" || (route === null || route === void 0 ? void 0 : route.pathname) === "/app/student/favorite/university") && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_unisearch_common_ui_element_actions_chat_connect__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            recieverType: "university",
            uniId: data.universityId
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_unisearch_common_ui_element_actions_conversation__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            email: data.universityMail
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
        className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_image_wrapper),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_6___default()), {
          layout: "responsive",
          width: 380,
          height: 175,
          blurDataURL: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAssets */ .Vh)("assets/images/study/country_placeholder.webp"),
          placeholder: "blur",
          className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().featured_image),
          src: data.featureImageSrc || (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAssets */ .Vh)("assets/images/image_placeholder_big.webp"),
          alt: data.universityName || "University Cover Photo"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
        className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_card_top),
        children: [data.rankFrom && parseInt(data.rankFrom) != 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
          className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_rank),
          children: ["Rank: ", data.rankingVarying, data.rankFrom, " ", parseInt(data.rankTo) != 0 && " - " + data.rankTo]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
          legacyBehavior: true,
          href: link || "#",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
            className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_logo_wrapper),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_6___default()), {
              width: 92,
              height: 37,
              blurDataURL: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAssets */ .Vh)("assets/images/uni-profile/logo-placeholder.png"),
              placeholder: "blur",
              src: data.logoSrc || (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAssets */ .Vh)("assets/images/uni-profile/logo-placeholder.png"),
              alt: "University Logo"
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
          legacyBehavior: true,
          href: link || "#",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
            className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_name),
            children: data.universityName
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("p", {
          className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_address),
          children: [data.universityType ? (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .upperFirstLetter */ .cK)(data.universityType) : "", " ", "university, Estd ", data.universityEstd]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("p", {
          className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_address),
          children: [data.cityName, ", ", data.stateName]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
        className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_card_bottom),
        children: [data.totalCourse && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
          className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_course_link_wrapper),
          children: [((_data$popularCourse3 = data.popularCourse) === null || _data$popularCourse3 === void 0 ? void 0 : _data$popularCourse3.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("button", {
            className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().btn_popular_course),
            id: "basic-button",
            "aria-controls": "basic-menu",
            "aria-haspopup": "true",
            "aria-expanded": open ? "true" : undefined,
            onClick: handleClick,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_14__/* .FiPlus */ .OvN, {}), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
              children: "Popular Courses"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            legacyBehavior: true,
            href: courseLink || "#",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("a", {
              className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_course_link),
              children: ["View All ", data.totalCourse, " Courses"]
            })
          })]
        }), (data === null || data === void 0 ? void 0 : data.overview) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
          className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_desc),
          children: data !== null && data !== void 0 && data.overview ? (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .excerpt */ .X1)(data.overview, 150) : ""
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
          className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().footer_btn_wrapper)
        })]
      })]
    })]
  });
};
/* harmony default export */ __webpack_exports__["Z"] = (TopRankUniCard);

/***/ }),

/***/ 20155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _banner_box_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28397);
/* harmony import */ var _banner_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_banner_box_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72145);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var BannerBox = function BannerBox(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    className: (_banner_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().image_wrapper),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default()), {
      layout: "responsive",
      width: 1900,
      height: 500,
      blurDataURL: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getAssets */ .Vh)("assets/images/study/country_placeholder.webp"),
      placeholder: "blur",
      className: (_banner_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().featured_image),
      src: (props === null || props === void 0 ? void 0 : props.image) || (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getAssets */ .Vh)("assets/images/study/country_placeholder.webp"),
      alt: (props === null || props === void 0 ? void 0 : props.alt) || "University Cover Photo"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: (_banner_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().overlay)
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: (_banner_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().banner_info),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
        className: (_banner_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
        children: [" ", props === null || props === void 0 ? void 0 : props.title]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
        className: (_banner_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().text),
        children: [(props === null || props === void 0 ? void 0 : props.university) || 0, " ", (props === null || props === void 0 ? void 0 : props.university) > 1 ? "Universities" : "University"]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
        className: (_banner_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().text),
        children: [(props === null || props === void 0 ? void 0 : props.courses) || 0, " ", (props === null || props === void 0 ? void 0 : props.courses) > 1 ? "Courses" : "Course"]
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BannerBox);

/***/ }),

/***/ 44138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ExploreUniList": function() { return /* binding */ ExploreUniList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _university_components_uni_thumb_grid_box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32182);
/* harmony import */ var _components_banner_box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20155);
/* harmony import */ var _modules_study_common_top_rank_uni_card__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49922);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72145);
/* harmony import */ var _explore_uni_list_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61405);
/* harmony import */ var _explore_uni_list_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_explore_uni_list_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);








var ExploreUniList = function ExploreUniList(_ref) {
  var _data$university;

  var countryWiseUniversity = _ref.countryWiseUniversity,
      topUniData = _ref.topUniData;
  var data = countryWiseUniversity;
  var courseCount = 0;
  data === null || data === void 0 ? void 0 : (_data$university = data.university) === null || _data$university === void 0 ? void 0 : _data$university.forEach(function (uni, i) {
    courseCount = courseCount + uni.courses.length;
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
      className: (_explore_uni_list_module_scss__WEBPACK_IMPORTED_MODULE_6___default().section_uni_list),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: "",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: (_explore_uni_list_module_scss__WEBPACK_IMPORTED_MODULE_6___default().wrapper),
          children: (topUniData === null || topUniData === void 0 ? void 0 : topUniData.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: (_explore_uni_list_module_scss__WEBPACK_IMPORTED_MODULE_6___default().uni_box_wrapper),
            children: topUniData === null || topUniData === void 0 ? void 0 : topUniData.map(function (item, i) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_modules_study_common_top_rank_uni_card__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                data: item
              }, i);
            })
          })
        })
      })
    })
  });
};
/* harmony default export */ __webpack_exports__["default"] = (ExploreUniList);

/***/ }),

/***/ 1961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rg": function() { return /* reexport */ ExploreBanner; },
  "cg": function() { return /* reexport */ ExploreList; }
});

// UNUSED EXPORTS: ExploreUniList

// EXTERNAL MODULE: ./_modules/study/explore/explore_banner.module.scss
var explore_banner_module = __webpack_require__(13461);
var explore_banner_module_default = /*#__PURE__*/__webpack_require__.n(explore_banner_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_modules/study/explore/explore_banner.jsx




var ExploreBanner = function ExploreBanner(_ref) {
  var title = _ref.title,
      description = _ref.description;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: (title || description) && /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: (explore_banner_module_default()).section_explore_banner,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (explore_banner_module_default()).wrapper,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (explore_banner_module_default()).text_wrapper,
            children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
              children: title
            }), description && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: description
            })]
          })
        })
      })
    })
  });
};
/* harmony default export */ var explore_banner = ((/* unused pure expression or super */ null && (ExploreBanner)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./_modules/study/common/top_rank_uni_card/index.jsx
var top_rank_uni_card = __webpack_require__(49922);
// EXTERNAL MODULE: ./_unisearch/helpers/api/index.js
var api = __webpack_require__(85014);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
// EXTERNAL MODULE: ./_modules/study/explore/components/banner_box/index.jsx
var banner_box = __webpack_require__(20155);
// EXTERNAL MODULE: ./_modules/study/explore/explore_list.module.scss
var explore_list_module = __webpack_require__(51866);
var explore_list_module_default = /*#__PURE__*/__webpack_require__.n(explore_list_module);
;// CONCATENATED MODULE: ./_modules/study/explore/explore_list.jsx













var ExploreList = function ExploreList(_ref) {
  var allExploreData = _ref.allExploreData,
      allCountry = _ref.allCountry;

  var _useState = (0,react.useState)(true),
      hasMore = _useState[0],
      setHasMore = _useState[1];

  var _useState2 = (0,react.useState)(allExploreData),
      allExploreCountryData = _useState2[0],
      setAllExploreCountryData = _useState2[1];

  var _useState3 = (0,react.useState)(2),
      page = _useState3[0],
      setPage = _useState3[1];

  var getMoreData = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var exploreAPI, getMoreCountryData;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setPage(page + 1);
              exploreAPI = "/public/university/explore-university?isTop=true&page=".concat(page);
              _context.next = 4;
              return api/* default.get */.Z.get(exploreAPI);

            case 4:
              getMoreCountryData = _context.sent;

              if (!getMoreCountryData.error && getMoreCountryData.data.length > 0) {
                setAllExploreCountryData(function (data) {
                  return [].concat((0,toConsumableArray/* default */.Z)(data), (0,toConsumableArray/* default */.Z)(getMoreCountryData.data));
                });
              } else {
                setHasMore(false);
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getMoreData() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: (allExploreCountryData === null || allExploreCountryData === void 0 ? void 0 : allExploreCountryData.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* default */.Z, {
      dataLength: allExploreCountryData.length,
      next: getMoreData,
      hasMore: hasMore,
      loader: /*#__PURE__*/(0,jsx_runtime.jsx)("small", {
        children: " Loading..."
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
        className: (explore_list_module_default()).section_explore_list,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (explore_list_module_default()).wrapper,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
              className: (explore_list_module_default()).explore_list,
              children: allExploreCountryData.map(function (country, i) {
                var _country$universityDa;

                if ((country === null || country === void 0 ? void 0 : (_country$universityDa = country.universityData) === null || _country$universityDa === void 0 ? void 0 : _country$universityDa.length) > 0) {
                  var _country$universityDa2, _country$universityDa3, _country$universityDa4;

                  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
                    children: (country === null || country === void 0 ? void 0 : (_country$universityDa2 = country.universityData) === null || _country$universityDa2 === void 0 ? void 0 : _country$universityDa2.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(banner_box/* default */.Z, {
                        image: (country === null || country === void 0 ? void 0 : country.src) || (0,helpers/* getAssets */.Vh)("assets/images/image_placeholder_big.webp"),
                        alt: country === null || country === void 0 ? void 0 : country.name,
                        title: country === null || country === void 0 ? void 0 : country.name,
                        university: country === null || country === void 0 ? void 0 : country.totalUni,
                        courses: country === null || country === void 0 ? void 0 : country.totalCourse
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: (explore_list_module_default()).title_wrapper,
                        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
                          children: [country === null || country === void 0 ? void 0 : country.name, "'s Top 10 Universities"]
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                          legacyBehavior: true,
                          href: "/".concat(country === null || country === void 0 ? void 0 : country.slug, "/university"),
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                            className: (explore_list_module_default()).link,
                            children: "View all universities \u203A"
                          })
                        })]
                      }), (country === null || country === void 0 ? void 0 : (_country$universityDa3 = country.universityData) === null || _country$universityDa3 === void 0 ? void 0 : _country$universityDa3.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: (explore_list_module_default()).uni_box_wrapper,
                        children: country === null || country === void 0 ? void 0 : (_country$universityDa4 = country.universityData) === null || _country$universityDa4 === void 0 ? void 0 : _country$universityDa4.map(function (item, i) {
                          return /*#__PURE__*/(0,jsx_runtime.jsx)(top_rank_uni_card/* default */.Z, {
                            data: item
                          }, i);
                        })
                      })]
                    })
                  }, i);
                }
              })
            })
          })
        })
      })
    })
  });
};
/* harmony default export */ var explore_list = ((/* unused pure expression or super */ null && (ExploreList)));
// EXTERNAL MODULE: ./_modules/study/explore/explore_uni_list.jsx
var explore_uni_list = __webpack_require__(44138);
;// CONCATENATED MODULE: ./_modules/study/explore/index.js




/***/ }),

/***/ 32182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72145);
/* harmony import */ var _unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90705);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89583);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5434);
/* harmony import */ var _uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47384);
/* harmony import */ var _uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);









var UniThumbGridBox = function UniThumbGridBox(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().box),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
      legacyBehavior: true,
      href: props.universityLink,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().image_wrapper),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
            src: props.featuredImage || (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAssets */ .Vh)("assets/images/uni-profile/harvard-university.jpg"),
            alt: props.featuredImageAlt || "University banner",
            className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().banner)
          }), props.logo && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().logo_wrapper),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
              src: props.logo,
              alt: props.logoAlt || "University logo",
              className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().logo)
            })
          })]
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().profile_box_content),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().infos),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
          legacyBehavior: true,
          href: props.universityLink,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
              className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().name),
              children: props.name || "University Name"
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().info),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().icon),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_5__/* .MdLocationOn */ .$0r, {})
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
            children: [props.address && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
              children: [props.address, ", "]
            }), props.city && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
              children: [props.city, ", "]
            }), props.state && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
              children: [props.state, ", "]
            }), props.country && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
              children: props.country
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().info),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().icon),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_6__/* .FaUniversity */ .Q7H, {
              style: {
                marginTop: "-4px"
              }
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
            children: [props.universityType && (0,_unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_1__/* .upperFirstLetter */ .cK)(props.universityType), " ", "University, ", props.estd && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
              children: ["Estd ", props.estd]
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("button", {
          className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().follow),
          children: "+ Follow"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().links),
        children: props.courseNumber !== 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
          legacyBehavior: true,
          href: props.courseLink,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("a", {
            className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().all_courses),
            children: ["View all ", props.courseNumber, " Courses \u203A"]
          })
        })
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (UniThumbGridBox);

/***/ }),

/***/ 71285:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"uni_rank_card":"top_rank_uni_card_uni_rank_card__FhfuD","uni_image_wrapper":"top_rank_uni_card_uni_image_wrapper__rLU4z","favorite_wrapper":"top_rank_uni_card_favorite_wrapper__DFWw4","uni_card_top":"top_rank_uni_card_uni_card_top__ENT_z","uni_rank":"top_rank_uni_card_uni_rank__icLc_","uni_card_bottom":"top_rank_uni_card_uni_card_bottom__O_y3c","uni_logo_wrapper":"top_rank_uni_card_uni_logo_wrapper__vruFJ","uni_name":"top_rank_uni_card_uni_name__yRzcW","uni_address":"top_rank_uni_card_uni_address__UfAg_","uni_course_link_wrapper":"top_rank_uni_card_uni_course_link_wrapper__4O6KO","btn_popular_course":"top_rank_uni_card_btn_popular_course__k_GKr","uni_course_link":"top_rank_uni_card_uni_course_link__Zxvol","uni_desc":"top_rank_uni_card_uni_desc__hFfZx","uni_ranking_wrapper":"top_rank_uni_card_uni_ranking_wrapper__hzaKE","ranking_title":"top_rank_uni_card_ranking_title__KKvcJ","footer_btn_wrapper":"top_rank_uni_card_footer_btn_wrapper__bkWnl","btn_follow":"top_rank_uni_card_btn_follow__6kpyL","download_link":"top_rank_uni_card_download_link__2IGXs","popular_course_dropdown":"top_rank_uni_card_popular_course_dropdown__TgHt_","popular_course_dropdown_wrapper":"top_rank_uni_card_popular_course_dropdown_wrapper__Fxv7p","dropdown_heading_wrapper":"top_rank_uni_card_dropdown_heading_wrapper__qP04H","dropdown_body_wrapper":"top_rank_uni_card_dropdown_body_wrapper__XVBNC","body_heading":"top_rank_uni_card_body_heading__9_Q_4","course_level":"top_rank_uni_card_course_level__vpQMV","course_name":"top_rank_uni_card_course_name__GpKQw","action_btn":"top_rank_uni_card_action_btn__Fr0UP"};

/***/ }),

/***/ 28397:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"banner_box___next__sWtgm","image_wrapper":"banner_box_image_wrapper__I4SOK","overlay":"banner_box_overlay__aAF7v","banner_info":"banner_box_banner_info__vO6uD","title":"banner_box_title__keAAC","text":"banner_box_text__FBGnU"};

/***/ }),

/***/ 13461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section_explore_banner":"explore_banner_section_explore_banner__u9vNo","wrapper":"explore_banner_wrapper__K_f0d","text_wrapper":"explore_banner_text_wrapper__Kccmb","search_wrapper":"explore_banner_search_wrapper__DTsUG","search_box":"explore_banner_search_box__iAo3P","icon":"explore_banner_icon__siszR","input":"explore_banner_input__8Tzyb"};

/***/ }),

/***/ 51866:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"explore_list___next__Vuj8W","section_explore_list":"explore_list_section_explore_list__BKvu6","wrapper":"explore_list_wrapper__eSlht","explore_list":"explore_list_explore_list__jtbWn","image_wrapper":"explore_list_image_wrapper__ST55C","overlay":"explore_list_overlay___xusb","banner_info":"explore_list_banner_info__Jwrq1","title":"explore_list_title__VUoGc","text":"explore_list_text__fyb7B","title_wrapper":"explore_list_title_wrapper__yMcg3","link":"explore_list_link__4le3M","uni_box_wrapper":"explore_list_uni_box_wrapper__4qPLz"};

/***/ }),

/***/ 61405:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section_uni_list":"explore_uni_list_section_uni_list__M2pYG","wrapper":"explore_uni_list_wrapper__3yrWS","banner_wrapper":"explore_uni_list_banner_wrapper__9uRXD","uni_box_wrapper":"explore_uni_list_uni_box_wrapper__zBRCo"};

/***/ }),

/***/ 47384:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"uni_thumb_grid_box___next__PWbmq","box":"uni_thumb_grid_box_box__W9voa","image_wrapper":"uni_thumb_grid_box_image_wrapper__AWQY2","banner":"uni_thumb_grid_box_banner__Zf_6n","logo_wrapper":"uni_thumb_grid_box_logo_wrapper__Cp3oL","logo":"uni_thumb_grid_box_logo__RM_tL","profile_box_content":"uni_thumb_grid_box_profile_box_content__gak3t","infos":"uni_thumb_grid_box_infos__fPlcm","name":"uni_thumb_grid_box_name__MElzQ","info":"uni_thumb_grid_box_info__WO_dQ","icon":"uni_thumb_grid_box_icon__Pqn4E","follow":"uni_thumb_grid_box_follow__PN7Lc","links":"uni_thumb_grid_box_links__AhukV","popular_courses":"uni_thumb_grid_box_popular_courses__JISnW","first":"uni_thumb_grid_box_first__snPsV","last":"uni_thumb_grid_box_last__apQqX","all_courses":"uni_thumb_grid_box_all_courses__KKNUC"};

/***/ }),

/***/ 25934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_browser_v4; }
});

;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ var esm_browser_validate = (validate);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = (stringify);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return esm_browser_stringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);

/***/ })

}]);